 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {useCallback, useEffect, useRef, useState} from 'react'



















export const getOnCompletedError = (
  res,
  errors
) => {
  const payload = res && Object.values(res)[0]
  return (payload && payload.error) || (errors && errors[0]) || undefined
}

const useMutationProps = () => {
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState(undefined)
  const isMountedRef = useRef(true)
  useEffect(() => {
    return () => {
      isMountedRef.current = false
    }
  }, [])

  const onCompleted = useCallback(
    (
      res,
      errors
    ) => {
      if (isMountedRef.current) {
        setSubmitting(false)
        setError(getOnCompletedError(res, errors))
      }
    },
    []
  )

  const onError = useCallback((error) => {
    setSubmitting(false)
    const sourceError = _optionalChain([(error ), 'optionalAccess', _ => _.source, 'optionalAccess', _2 => _2.errors, 'optionalAccess', _3 => _3[0]])
    setError(sourceError || error)
  }, [])

  const submitMutation = useCallback(() => {
    setSubmitting(true)
  }, [])

  return {submitting, submitMutation, error, onError, onCompleted}
}

export default useMutationProps
